import React from 'react';
import { ActivityIndicator } from 'antd-mobile';
import Nav from '@/components/NavBars';
import { Icon } from 'antd-mobile';
import { goBack } from '@/utils/bridge';

// loading components from code split
// https://umijs.org/plugin/umi-plugin-react.html#dynamicimport
export default () => (
  <div>
    <Nav
      title={'加载中'}
      icon={
        <Icon
          size={'md'}
          color={'#000000'}
          type="left"
          onClick={() => goBack()}
        />
      }
    />
    <div
      style={{
        height: document.documentElement.clientHeight - 44,
        width: document.documentElement.clientWidth,
      }}
    >
      <ActivityIndicator toast text="Loading..." animating={true} />
    </div>
  </div>
);
